// extracted by mini-css-extract-plugin
module.exports = {"l_section__inner":"LayoutSectionInner_l_section__inner__dUTWE"};